
import { Vue, Component, Watch } from "vue-property-decorator";
import ApplyForm from "@/components/ApplyForm.vue";
import PictureSlide from "@/components/PictureSlide.vue";
import FaqSection from "@/components/FaqSection.vue";
import { formatUpyunUrl } from "@/utils";
// import {openJesongChat} from "easy"
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { generateMetaInfo, getServiceJsonLd } from "@/utils/seo";

@Component({
  components: {
    ApplyForm,
    PictureSlide,
    Breadcrumb,
    FaqSection
  }
})
export default class weixue extends Vue {
  // FAQ 数据
  faqList = [
    { question: "微学平台是什么？有哪些版本？", answer: "微学是光华数字化旗下的企业级在线学习平台，定位为「基于组织学习的数字化管理与运营平台，专业赋能成长型企业全员学习」，帮助企业搭建自己的在线学习平台，实现线上线下内部外部360°学习管理，是企业构建学习型组织、沉淀内部知识、提升员工能力的数字化工具。C1-C4四象限学习管理是微学的核心理念，覆盖企业学习的全部场景：C1线上外部课程——光华提供的海量外部优质课程，员工可在线学习；C2线上内部课程——企业上传的内部培训课程、知识文档、操作视频等，实现内部知识沉淀和传承；C3线下内部课程——企业组织的内部培训、内训课程等，可在平台上进行报名、签到、评估等管理；C4线下外部课程——员工参加的外部公开课、训战营等，可在平台上进行记录和管理。核心能力：海量课程库——光华提供3000门+课程、2593名讲师资源、5000+课时，涵盖战略、管理、营销、人力、生产、财务、AI等各领域；内部知识沉淀——企业可上传内部课程、知识文档、操作视频等，构建企业自己的知识库；学习运营与管理——支持学习计划制定、课程分配、学习进度跟踪、学习数据统计等功能；培训数字化管理——支持线下培训的报名、签到、评估、证书等全流程数字化管理；数据化反馈——提供丰富的学习数据报表和分析，帮助企业了解员工学习情况、评估培训效果、优化培训计划。微学还是全网唯一「科学经营频道」的在线学习平台，提供学考练用一体化学习体验。三个版本对比：微学（商学院版）——全平台课程（350门+），全平台功能，标配科学经营频道，300元/端口/年，20个起；微学（尊享版）——全平台功能，部分课程（280门），不含科学经营频道，99元/端口/年，50个起；微学（标准版）——部分基础必要功能，部分课程（116门），不含科学经营频道，39元/端口/年，50个起。版本选择建议：商学院版适合希望全面使用光华课程资源和科学经营频道的企业；尊享版适合需要全平台功能但对课程数量要求适中的企业，性价比高；标准版适合预算有限、只需要基础学习功能和少量课程的企业。微学平台可与GTT绩效飞轮配合使用，形成「绩效管理+学习发展」的数字化管理闭环。" },
    { question: "ELP云学习和光华商学有什么区别？", answer: "ELP云学习和光华商学都是光华数字化旗下的在线学习产品，但定位、目标人群、功能特点和价格模式有显著区别，分别服务于不同规模和需求的企业。ELP云学习平台——大企业在线学习平台，定位为提供企业全方位数字培训难题解决方案，丰富的课程资源、多元的学习入口、场景化运营渗透、O2O项目支持，帮助企业一站式构建学习平台，全面加速人才培养和绩效转化，目标人群是1000人以上中大型企业，ELP是为中大型企业量身打造的企业级在线学习平台，适合员工规模大、培训需求复杂、需要系统化培训管理的企业。八大培训解决方案：新员工入职培训、经理人领导力培训、合规培训、销售体系培训、合作伙伴培训、全员学习解决方案、新产品培训、员工职业发展培训，覆盖企业培训的全场景需求。三大体系：运营体系——技术支持、运营支持、线下沙龙、做课方案，提供全方位运营支持；产品体系——学习平台ELP5.0云端学习、平台工具（看见、易企播、简课、福利社、数据看板），功能强大；内容体系——通用课程、行业课程、直播课程、定制课程、合作课程，内容丰富。数据见证：22年行业发展经验、36个总部/分支机构、1200万+E-learning付费用户、150万+每年新增用户、10000+中大型合作企业、5000+课时、2593名讲师资源、3000门+课程。价格：500元/端口/年，50个起，ELP按端口收费，适合中大型企业批量采购。光华商学——个人及企业学习小组移动学习平台，定位为个人及企业学习小组移动学习平台，九大学堂390+门课程，4900+小节，满足各种个人及企业学习小组的学习需求，目标人群是个人学习者及企业学习小组，光华商学更偏向个人自主学习和小型团队学习，适合个人提升或企业小团队的碎片化学习需求。九大学堂：总裁学堂——战略、股权、绩效、管理；管理学堂——管理、领导、激励、胜任；电商学堂——流量、爆款、运营、营销；职场学堂——办公技能、思维、沟通、协作；人力学堂——薪酬、绩效、管理、激励；营销学堂——营销、策略、管理、思维；生产学堂——物流、精益、班组、效率；家道学堂——家庭、亲子、沟通、教育；科学经营学堂——科学经营一册、一张大表分拆对。课程形式：优选全国实力名师现场实录课程、结构化课程体系化学习（碎片化学习）、结构化知识体系、精品课试听，支持APP下载免费试听。特色：全网唯一「科学经营频道」，提供学考练用一体化学习体验，光华商学APP可免费下载试听，降低了用户的体验门槛。价格：光华商学APP可免费下载试听，具体订阅价格可咨询顾问或在APP内查看。核心区别总结：定位——ELP是大企业在线学习平台，光华商学是个人及企业学习小组移动学习平台；目标人群——ELP面向1000人以上中大型企业，光华商学面向个人学习者及企业学习小组；课程数量——ELP有3000门+课程、5000+课时，光华商学有390+门课程、4900+小节；功能深度——ELP有企业级培训管理、八大解决方案、三大体系，光华商学有移动学习、碎片化学习、九大学堂；运营支持——ELP有技术支持、运营支持、线下沙龙、做课方案，光华商学以自主学习为主；价格模式——ELP 500元/端口/年，50个起，光华商学APP免费试听，订阅制；适合场景——ELP适合企业系统化全员培训、培训体系建设，光华商学适合个人自主学习、小团队碎片化学习。选择建议：1000人以上中大型企业需要系统化培训管理，选择ELP云学习；个人学习者或企业小团队需要碎片化移动学习，选择光华商学。两者也可配合使用，企业用ELP做系统化培训管理，员工用光华商学APP做个人自主学习。" }
  ];
  get metaInfo() {
    return generateMetaInfo({
      title: "微学 | 学·考·练·用，企业培训数字化管理平台 - 光华赋能",
      description:
        "光华微学是企业培训数字化管理平台，涵盖学、考、练、用全流程，提供学习运营与管理、海量课程库、数据化反馈、内部知识沉淀，帮助企业实现培训数字化转型。",
      keywords:
        "微学,企业培训平台,培训数字化,学习管理系统,LMS,在线培训,企业学习,知识沉淀,光华赋能",
      path: "/weixue",
      breadcrumb: [
        { name: "首页", url: "/" },
        { name: "数字化" },
        { name: "微学" }
      ],
      jsonLd: getServiceJsonLd({
        name: "微学",
        description:
          "企业培训数字化管理平台，涵盖学、考、练、用全流程，提供学习运营、课程库、数据反馈、知识沉淀等功能。",
        category: "企业培训管理平台"
      })
    });
  }

  formatUpyunUrl = formatUpyunUrl;
  pic1 = "/img/46ca14bd2d83fcb93ee5433e47408105.png";
  pic2 = "/img/7a0f2b1d6b8a7e54251abde21128ed39.png";
  pic3 = "/img/a9967ea3fb6bda69c9b11ee2a1fa436e.png";
  pic4 = "/img/894ed857c406df3d3d994a927527431a.png";
  pic5 = "/img/df6fa5d2f7a00205282823aca3910f28.png";

  List = [
    { title: "数字化", url: "" },
    { title: "微学", url: "" }
  ];

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "数字化方案陪跑，EPM企业绩效系统，绩效飞轮，ELP，微学，光华商学"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "专家，落地指导，规划，战略到执行，数字化转型方案，数字化，转型，数字化+，+数字化，数字化管理体系，业务转型，效率提升，持续增长，底层框架 ,全盘规划,从战略到执行全流程,过程,落地,问题,目标,调研,诊断,成果,复盘,赛道分析,企业位置,行业趋势,企业现状营收、盈利、规模、定位、生态位、战略控制点、价值主张,组织与人才,人才、组织盘点,结构、员工数,管理体系机制、制度、流程（尤其是业务主流程）、股权,差距分析,机会差距,业绩差距,三找,找差距、找不满、,找原因,梳理核心问题,对标对标杆,对历史数据,对BLM,目标共识,FCIL四个角度,企业培训,海量课程库，阶段目录，有序学习，要点检测，成果考核，加深理解，记忆实践，巧用关联，灵活使用，学，考，练，用，个人学习，缺乏体系，员工提升，管理层、电商、营销等不同团队缺乏专属课程资源，无法进行精准的专项培训，人才培养效率低下，因学习资源与培训体系不完善，导致关键岗位的能力成长缓慢，业务发展受到制约，人才培养的滞后，最终成为企业创新与增长步伐的瓶颈，实力名师，体系化学习，结构化知识体系，精品课，试听"
    );
    document.head.appendChild(metaTag2);
  }
  beforeDestroy() {
    // 移除之前添加的meta标签，防止内存泄漏
    const metas1 = document.head.querySelectorAll('meta[name="keywords"]');
    metas1.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
    const metas2 = document.head.querySelectorAll('meta[name="description"]');
    metas2.forEach((meta: any) => {
      meta.parentNode.removeChild(meta);
    });
  }
}
